'use strict';

const ctrl = ['$state', '$scope', function ($state, $scope) {
    var _this = this;

    // ---- Helpers de rango (réplica de ItemsStore.getErrorElement de field4) ----
    // Unidades: date -> días ; time -> horas. time NO usa allowFuture/maxFuture.
    this.startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    this.endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);

    this.getDateMin = () => {
        const v = _this.field.validation || {};
        const td = _this.field.templateData || {};
        const allowPrevious = td.allow_old_dates || v.allowPrevious;
        if (!allowPrevious) return _this.startOfDay(new Date());
        if (v.maxPrevious && Number(v.maxPrevious) > 0) {
            const d = new Date();
            d.setDate(d.getDate() - Number(v.maxPrevious));
            return _this.startOfDay(d);
        }
        return null; // sin límite
    };

    this.getDateMax = () => {
        const v = _this.field.validation || {};
        if (!v.allowFuture) return _this.endOfDay(new Date());
        if (v.maxFuture && Number(v.maxFuture) > 0) {
            const d = new Date();
            d.setDate(d.getDate() + Number(v.maxFuture));
            return _this.endOfDay(d);
        }
        return null; // sin límite
    };

    this.getTimeMin = () => {
        const v = _this.field.validation || {};
        const td = _this.field.templateData || {};
        const allowPrevious = td.allow_old_times || v.allowPrevious;
        const d = new Date();
        d.setSeconds(0, 0);
        if (!allowPrevious) return d;
        if (v.maxPrevious && Number(v.maxPrevious) > 0) {
            d.setHours(d.getHours() - Number(v.maxPrevious));
            return d;
        }
        return null; // sin límite
    };

    this.validate = () => {
        const v = _this.field.validation || {};
        const value = _this.model[_this.field.id].value;
        const errs = [];
        const empty = value === undefined || value === null || value === '';

        if (v.required && empty) {
            errs.push('Campo obligatorio');
        }

        if (!empty && (_this.field.type === 'date' || _this.field.type === 'time')) {
            const valDate = new Date(value);
            const min = _this.field.type === 'date' ? _this.getDateMin() : _this.getTimeMin();
            const max = _this.field.type === 'date' ? _this.getDateMax() : null; // time no tiene futuro
            if (min && valDate < min) {
                errs.push(_this.field.type === 'date'
                    ? 'Fuera del rango permitido: debe ser igual o posterior a '.concat(min.getYYYYMMdd())
                    : 'Fuera del rango permitido: debe ser igual o posterior a las '.concat(min.getYYYYMMddHHmmss().substr(11, 5)));
            }
            if (max && valDate > max) {
                errs.push('Fuera del rango permitido: debe ser igual o anterior a '.concat(max.getYYYYMMdd()));
            }
        }

        _this.errorList = errs;
        _this.model[_this.field.id].valid = errs.length === 0;
    };

    // date -> ISO normalizado a mediodía local para evitar corrimiento de día por timezone
    // (el historial muestra con toLocaleDateString).
    this.onDateChange = () => {
        const d = _this.dateModel;
        if (d instanceof Date && !isNaN(d.getTime())) {
            _this.model[_this.field.id].value = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0).toISOString();
        } else {
            _this.model[_this.field.id].value = undefined;
        }
        _this.validate();
    };

    // time -> fecha de hoy + hora elegida, guardado como ISO (mismo criterio que field4).
    this.onTimeChange = () => {
        const t = _this.timeModel;
        if (t instanceof Date && !isNaN(t.getTime())) {
            const now = new Date();
            _this.model[_this.field.id].value = new Date(now.getFullYear(), now.getMonth(), now.getDate(), t.getHours(), t.getMinutes(), 0, 0).toISOString();
        } else {
            _this.model[_this.field.id].value = undefined;
        }
        _this.validate();
    };

    // timestamp -> estampa el "ahora" al activar, undefined al desactivar (igual que field4).
    this.onTimestampToggle = () => {
        if (_this.field.templateData && _this.field.templateData.readOnly) return;
        _this.timestampOn = !_this.timestampOn;
        _this.model[_this.field.id].value = _this.timestampOn ? new Date().toISOString() : undefined;
        _this.validate();
    };

    // ---- Init ----
    // date/time/timestamp: el valor se guarda SIEMPRE como ISO string (igual que en field4),
    // para que el historial y los reportes lo lean con new Date(value).
    // AngularJS 1.4 exige un objeto Date en ng-model para input[type=date|time], por eso
    // se usan modelos intermedios (dateModel/timeModel) y se convierte a ISO en cada cambio.
    this.model[_this.field.id] = this.model[_this.field.id] || {
        type: _this.field.type,
        id: _this.field.id,
        value: undefined,
    };

    this.errorList = [];

    const current = this.model[_this.field.id].value;

    if (_this.field.type === 'date') {
        if (current) this.dateModel = new Date(current);
        const dMin = this.getDateMin();
        const dMax = this.getDateMax();
        this.dateMinLabel = dMin ? dMin.getYYYYMMdd() : '';
        this.dateMaxLabel = dMax ? dMax.getYYYYMMdd() : '';
    } else if (_this.field.type === 'time') {
        if (current) this.timeModel = new Date(current);
    } else if (_this.field.type === 'timestamp') {
        // autoSet: si el campo se configuró para setearse al crear el registro y todavía no
        // tiene valor, se activa automáticamente con la fecha/hora del momento (switch en verde).
        if (_this.field.autoSet && !current) {
            this.model[_this.field.id].value = new Date().toISOString();
        }
        this.timestampOn = !!this.model[_this.field.id].value;
    }

    if (['date', 'time', 'timestamp'].indexOf(_this.field.type) !== -1) {
        this.validate();
    }
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            model: '=',
            item: '=',
            validatePayload: '=',
        },
        controller: ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/fieldElementDirective.html'
    };
};
